import { formatDate } from './formatDate';
export const getDateSummary = (startDate, endDate, includeYear) => {
    return startDate
        ? `${formatDate(startDate, includeYear)} - ${endDate ? formatDate(endDate, includeYear) : ''}`
        : '';
};
export const getDate = (date, includeYear) => {
    return date ? `${formatDate(date, includeYear)}` : '';
};
